import createTabStore from '../../store/createTabStore';
import SchemeDefinitionService from '../../services/schemedefination.service';

export const [useSchemeStore, useSchemeStoreApi] = createTabStore((set, get) => {
// Each tab owns its initial values as well as its actions.
const initialState = {
    // schemeCommon
    loading: false,
    error: null,
    serviceInstance: null,
    schemeId: null,
    tabValue: 0,
    prevTabValue: 0,
    formData: {},
    errorTab: null,
    validationErrorMessage: null,
    apiResponse: null,

    definitionData: null,
    slabFormData: null,
    areaData: null,
    itemData: null,
    retailerData: null,
    distributorData: null,
    targetData: null,
    pointData: null,
    mailMessageData: null,
    conditionalCriteriaData: null,
    contributionItemData: null,
    liftingUOMName: null,


    // SchemeDefinition Tab
    schemeDetails: null,
    parentSchemeDetails: null,
    schemeControls: [],
    primaryCategoryControls: [],
    executiveDefControls: [],
    schemeDivisionControls: [],
    criteriaHandlingControls: [],
    newCustomerControls: [],
    distributorBeneficiaryControls: [],
    schemeData: null,
    schemeDocuments: [],
    conversionRateControl: [],
    pointBasedSlabRepeatationCriteriaControls: [],

    // SchemeSlab Tab
    schemeSlabControls: [],
    slabPopupDiscountControls: [],
    slabPopupGiftControls: [],
    slabPopupFreeitemControls: [],
    slabData: [],
    editSlabData: null,
    editedSlabId: null,
    slabMainGridData: [],
    thresholdSettings: null,

};

    // Immediately fetch and store the service instance
    (async () => {
        const service = await SchemeDefinitionService;
        set({ serviceInstance: service });
    })();

    return {
        ...initialState,

        // Reset function
        reset: () => set(initialState),

        // Setters
        setDefinitionData: (data) => set({ definitionData: data }),
        setLiftingUOMName: (data) => set({ liftingUOMName: data }),
        setSlabFormData: (data) => set({ slabFormData: data }),
        setAreaData: (data) => set({ areaData: data }),
        setApiResponse: (data) => set({ apiResponse: data }),
        setSchemeId: (data) => set({ schemeId: data }),
        setItemData: (data) => set({ itemData: data }),
        setRetailerData: (data) => set({ retailerData: data }),
        setDistributorData: (data) => set({ distributorData: data }),
        setTargetData: (data) => set({ targetData: data }),
        setPointData: (data) => set({ pointData: data }),
        setMailMessageData: (data) => set({ mailMessageData: data }),
        setConditionalCriteriaData: (data) => set({ conditionalCriteriaData: data }),
        setContributionItemData: (data) => set({ contributionItemData: data }),
        setFormData: (data) => set({ formData: data }),
        setTabValue: (data) => set({ tabValue: data }),
        setPrevTabValue: (data) => set({ prevTabValue: data }),
        setSchemeData: (data) => set({ schemeData: data }),
        setSlabData: (data) => set({ slabData: data }),
        setEditSlabData: (data) => set({ editSlabData: data }),
        setEditedSlabId: (data) => set({ editedSlabId: data }),
        setSlabMainGridData: (data) => set({ slabMainGridData: data }),
        setThresholdSettings: (data) => set({ thresholdSettings: data }),


        addScheme: async () => { // NOSONAR
            set({ loading: true, error: null });
            try {
                const {
                    definitionData,
                    slabFormData,
                    areaData,
                    itemData,
                    retailerData,
                    distributorData,
                    targetData,
                    pointData,
                    mailMessageData,
                    conditionalCriteriaData,
                    contributionItemData,
                    errorTab,
                    setPointData,
                    setTargetData,
                    setMailMessageData,
                    setConditionalCriteriaData,
                    setContributionItemData,
                    setApiResponse,
                    liftingUOMName,
                    setSchemeId,
                    schemeData
                } = get();

                const requiredFields = {
                    definitionData,
                    slabFormData,
                    areaData,
                    itemData,
                    retailerData,
                    distributorData,
                    targetData,
                    pointData,
                    mailMessageData,
                    conditionalCriteriaData,
                    contributionItemData,
                };


                if (definitionData?.AdditionalRebate) {
                    const hasContributionItem = !!contributionItemData;
                    const hasSlabs = Array.isArray(slabFormData) &&
                        slabFormData.length > 0 &&
                        slabFormData.every(slab => !!slab.ContributionQuantity);

                    if (!hasContributionItem && !hasSlabs) {
                        set({ validationErrorMessage: "Please select contribution item and slab contribution quantity." })
                        set({ error: null, loading: false });
                        return;
                        // eslint-disable-next-line no-else-return
                    } else if (!hasContributionItem) {
                        set({ validationErrorMessage: "Please select contribution item." })
                        set({ error: null, loading: false });

                        return;

                    } else if (!hasSlabs) {
                        set({ validationErrorMessage: "Please select slab contribution quantity." });
                        set({ error: null, loading: false });

                        return;

                    }

                }
                set({ validationErrorMessage: null });

                if (!schemeData?.AdditionalRebate) {
                    setContributionItemData(null);
                }

                if (!schemeData?.IsPointBasedScheme) {
                    setPointData(null);
                } else if (pointData == null) {
                    const message = 'Please validate Point details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }

                if (!schemeData?.IncludeTarget) {
                    setTargetData(null);
                } else if (targetData == null) {
                    const message = 'Please validate Target details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }

                if (!schemeData?.IsConditionalScheme) {
                    setConditionalCriteriaData(null);
                } else if (conditionalCriteriaData == null) {
                    const message = 'Please validate Conditional Criteria details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }

                if (!schemeData?.IsSchemeMailCirculation) {
                    setMailMessageData(null);
                } else if (mailMessageData == null || mailMessageData?.MailMessage === "<p><br></p>" || mailMessageData?.MailMessage.trim() === '' || mailMessageData?.MailMessage === '') {
                    const message = 'Please validate Mail Message details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }


                // eslint-disable-next-line no-restricted-syntax
                for (const [key, value] of Object.entries(requiredFields)) {
                    if (value === 'error') {
                        const tabName = key.replace(/Data$/, '').replace(/Form$/, '').replace(/([A-Z])/g, ' $1').trim();
                        const errorMessage = `Please validate ${tabName} details.`;
                        const isSame = errorTab?.trim() === errorMessage;
                        const toggledErrorMessage = isSame && errorTab.endsWith(' ')
                            ? errorMessage
                            : `${errorMessage} `;

                        set({ loading: false, errorTab: toggledErrorMessage });
                        console.error(errorMessage);
                        return;
                    }
                }

                const {
                    SchemeDocument,
                    From_FromDate,
                    To_ToDate,
                    ...filteredData
                } = schemeData || {};

                const filters = [];
                if (areaData && (Array.isArray(areaData) ? areaData[0] : areaData) != null)
                    filters.push(Array.isArray(areaData) ? areaData[0] : areaData);
                if (itemData && (Array.isArray(itemData) ? itemData[0] : itemData) != null)
                    filters.push(Array.isArray(itemData) ? itemData[0] : itemData);
                if (distributorData && (Array.isArray(distributorData) ? distributorData[0] : distributorData) != null)
                    filters.push(Array.isArray(distributorData) ? distributorData[0] : distributorData);
                if (retailerData && (Array.isArray(retailerData) ? retailerData[0] : retailerData) != null)
                    filters.push(Array.isArray(retailerData) ? retailerData[0] : retailerData);

                const scheme = {
                    Id: '',
                    ...filteredData,
                    IsActive: true
                };



                scheme.Filters = filters;
                if (scheme?.IncludeTarget && targetData) scheme.Target = targetData;
                if (scheme?.IsPointBasedScheme && pointData) scheme.Point = pointData;
                if (slabFormData) scheme.Slabs = slabFormData;
                if (scheme?.AdditionalRebate && contributionItemData) scheme.ContributionItem = contributionItemData;
                if (scheme?.IsSchemeMailCirculation && mailMessageData) scheme.MailCirculation = mailMessageData;
                if (scheme?.IsConditionalScheme && conditionalCriteriaData) scheme.ConditionalCriteria = conditionalCriteriaData;
                if (SchemeDocument) {
                    scheme.SchemeDocument = SchemeDocument.map(item => ({ Name: item?.name }));
                }

                const payload = [
                    {
                        FromDate: From_FromDate,
                        ToDate: To_ToDate,
                        LiftingUOM: liftingUOMName || 'Target%',
                        Scheme: scheme
                    }
                ];

                const service = await SchemeDefinitionService;
                const formData = new FormData();
                formData.append("schemeJSON", JSON.stringify(payload));
                if (definitionData?.SchemeDocument) {
                    definitionData.SchemeDocument.forEach(item => {
                        formData.append('files', item);
                    });
                }

                const response = await service.AddScheme(formData);
                setApiResponse(response || null);
                if (response?.data?.SchemeId) {
                    setSchemeId(response?.data?.SchemeId);
                }
                set({ loading: false });
            } catch (err) {
                console.error('Update scheme error:', err);
                set({ error: err?.response?.data?.error?.message || 'Failed to add scheme.', loading: false });
                throw err;
            }
        },
        updateScheme: async () => {
            set({ loading: true, error: null });
            try {
                const {
                    definitionData,
                    slabFormData,
                    areaData,
                    itemData,
                    retailerData,
                    distributorData,
                    targetData,
                    pointData,
                    mailMessageData,
                    conditionalCriteriaData,
                    contributionItemData,
                    schemeId,
                    errorTab,
                    setPointData,
                    setTargetData,
                    setMailMessageData,
                    setConditionalCriteriaData,
                    setContributionItemData,
                    setApiResponse,
                    liftingUOMName,
                    schemeData
                } = get();

                const requiredFields = {
                    definitionData,
                    slabFormData,
                    areaData,
                    itemData,
                    retailerData,
                    distributorData,
                    targetData,
                    pointData,
                    mailMessageData,
                    conditionalCriteriaData,
                    contributionItemData,
                };


                if (schemeData?.AdditionalRebate) {
                    const hasContributionItem = !!contributionItemData;
                    const hasSlabs = Array.isArray(slabFormData) &&
                        slabFormData.length > 0 &&
                        slabFormData.every(slab => !!slab.ContributionQuantity);

                    if (!hasContributionItem && !hasSlabs) {
                        set({ validationErrorMessage: "Please select contribution item and slab contribution quantity." })
                        set({ error: null, loading: false });
                        return;
                        // eslint-disable-next-line no-else-return
                    } else if (!hasContributionItem) {
                        set({ validationErrorMessage: "Please select contribution item." })
                        set({ error: null, loading: false });

                        return;

                    } else if (!hasSlabs) {
                        set({ validationErrorMessage: "Please select slab contribution quantity." });
                        set({ error: null, loading: false });

                        return;

                    }

                }
                set({ validationErrorMessage: null });

                if (!schemeData?.AdditionalRebate) {
                    setContributionItemData(null);
                }

                if (!schemeData?.IsPointBasedScheme) {
                    setPointData(null);
                } else if (pointData == null) {
                    const message = 'Please validate Point details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }

                if (!schemeData?.IncludeTarget) {
                    setTargetData(null);
                } else if (targetData == null) {
                    const message = 'Please validate Target details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }

                if (!schemeData?.IsConditionalScheme) {
                    setConditionalCriteriaData(null);
                } else if (conditionalCriteriaData == null) {
                    const message = 'Please validate Conditional Criteria details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }

                if (!schemeData?.IsSchemeMailCirculation) {
                    setMailMessageData(null);
                } else if (mailMessageData == null || mailMessageData?.MailMessage === "<p><br></p>" || mailMessageData?.MailMessage.trim() === '' || mailMessageData?.MailMessage === '') {
                    const message = 'Please validate Mail Message details';
                    set({ loading: false, errorTab: errorTab?.endsWith(' ') ? message : ` ${message} ` });
                    return;
                }



                // eslint-disable-next-line no-restricted-syntax
                for (const [key, value] of Object.entries(requiredFields)) {
                    if (value === 'error') {
                        const tabName = key.replace(/Data$/, '').replace(/Form$/, '').replace(/([A-Z])/g, ' $1').trim();
                        const errorMessage = `Please validate ${tabName} details.`;
                        const isSame = errorTab?.trim() === errorMessage;
                        const toggledErrorMessage = isSame && errorTab.endsWith(' ')
                            ? errorMessage
                            : `${errorMessage} `;

                        set({ loading: false, errorTab: toggledErrorMessage });
                        console.error(errorMessage);
                        return;
                    }
                }

                const {
                    SchemeDocument,
                    From_FromDate,
                    To_ToDate,
                    ...filteredData
                } = definitionData || {};

                const filters = [];
                if (areaData && (Array.isArray(areaData) ? areaData[0] : areaData) != null)
                    filters.push(Array.isArray(areaData) ? areaData[0] : areaData);
                if (itemData && (Array.isArray(itemData) ? itemData[0] : itemData) != null)
                    filters.push(Array.isArray(itemData) ? itemData[0] : itemData);
                if (distributorData && (Array.isArray(distributorData) ? distributorData[0] : distributorData) != null)
                    filters.push(Array.isArray(distributorData) ? distributorData[0] : distributorData);
                if (retailerData && (Array.isArray(retailerData) ? retailerData[0] : retailerData) != null)
                    filters.push(Array.isArray(retailerData) ? retailerData[0] : retailerData);

                const scheme = {
                    Id: schemeId,
                    ...filteredData,
                    IsActive: true
                };


                scheme.Filters = filters;
                if (scheme?.IncludeTarget && targetData) scheme.Target = targetData;
                if (scheme?.IsPointBasedScheme && pointData) scheme.Point = pointData;
                if (slabFormData) scheme.Slabs = slabFormData;
                if (scheme?.AdditionalRebate && contributionItemData) scheme.ContributionItem = contributionItemData;
                if (scheme?.IsSchemeMailCirculation && mailMessageData) scheme.MailCirculation = mailMessageData;
                if (scheme?.IsConditionalScheme && conditionalCriteriaData) scheme.ConditionalCriteria = conditionalCriteriaData;
                if (SchemeDocument) {
                    scheme.SchemeDocument = SchemeDocument.map(item => ({ Name: item?.name }));
                }

                const payload = {
                    SchemeJSON: [
                        {
                            FromDate: From_FromDate,
                            ToDate: To_ToDate,
                            LiftingUOM: liftingUOMName || 'Target%',
                            Scheme: scheme
                        }
                    ]
                };

                const service = await SchemeDefinitionService;
                const formData = new FormData();
                formData.append("schemeJSON", JSON.stringify(payload));
                if (definitionData?.SchemeDocument) {
                    definitionData.SchemeDocument.forEach(item => {
                        formData.append('files', item);
                    });
                }

                const response = await service.UpdateScheme(formData);
                setApiResponse(response || null);
                set({ loading: false });
            } catch (err) {
                console.error('Update scheme error:', err);
                set({ error: err?.response?.data?.error?.message || 'Failed to update scheme.', loading: false });
                throw err;
            }
        },

        fetchSchemeSetup: async (id, isCopyScheme) => {
            set({ loading: true, error: null, schemeId: id });
            try {
                const service = await SchemeDefinitionService;

                const [
                    controlsRes,
                    detailsRes,
                    primaryCalcControlsRes,
                    executiveDefControlsRes,
                    schemeDivisionControlsRes,
                    criteriaHandlingControlsRes,
                    newCustomerControlsRes,
                    distributorBeneficiaryControlsRes,
                    pointBasedSlabRepeatationCriteriaControlsRes,
                ] = await Promise.all([
                    service.GetSchemeMandatoryData(),
                    service.GetSchemeDetails(id),
                    service.GetPrimaryCalculationCategoryControls(),
                    service.GetExecutiveDefinitionControls(),
                    service.GetIsSchemeDivisionWiseControls(),
                    service.GetSchemeCriteriaHandlingControls(),
                    service.GetNewCustomerDefinitionControls(),
                    service.GetDistributorBeneficiaryControls(),
                    service.GetSecondarySchemesSlabRepeatationCriteriaControls(),
                ]);

                set({
                    schemeControls: controlsRes.data,
                    schemeDetails: isCopyScheme ? { ...detailsRes.data, SchemeLock: null } : detailsRes.data,
                    primaryCategoryControls: primaryCalcControlsRes.data,
                    executiveDefControls: executiveDefControlsRes.data,
                    schemeDivisionControls: schemeDivisionControlsRes.data,
                    criteriaHandlingControls: criteriaHandlingControlsRes.data,
                    newCustomerControls: newCustomerControlsRes.data,
                    distributorBeneficiaryControls: distributorBeneficiaryControlsRes.data,
                    pointBasedSlabRepeatationCriteriaControls: pointBasedSlabRepeatationCriteriaControlsRes.data,

                    loading: false,
                });
            } catch (err) {
                console.error('Scheme fetch error:', err);
                set({ error: err?.response?.data?.error?.message || 'Failed to fetch scheme setup data.', loading: false });
            }
        },
        fetchConversionRateControl: async (payload) => {
            set({ error: null });

            try {
                const {
                    areaData,
                    retailerData,
                    distributorData,
                    itemData,
                    schemeData
                } = get();
                const service = await SchemeDefinitionService;
                const filters = [];
                if (areaData && (Array.isArray(areaData) ? areaData[0] : areaData) != null)
                    filters.push(Array.isArray(areaData) ? areaData[0] : areaData);
                if (itemData && (Array.isArray(itemData) ? itemData[0] : itemData) != null)
                    filters.push(Array.isArray(itemData) ? itemData[0] : itemData);
                if (distributorData && (Array.isArray(distributorData) ? distributorData[0] : distributorData) != null)
                    filters.push(Array.isArray(distributorData) ? distributorData[0] : distributorData);
                if (retailerData && (Array.isArray(retailerData) ? retailerData[0] : retailerData) != null)
                    filters.push(Array.isArray(retailerData) ? retailerData[0] : retailerData);

                const payloadd = {
                    "Filters": filters,
                    "FromDate": schemeData?.From_FromDate,
                    "ToDate": schemeData?.To_ToDate,
                }

                if (Array.isArray(payloadd) && payloadd.length === 0) {
                    // If payload is an empty array, set empty array without calling API
                    set({
                        conversionRateControl: [],
                    });
                } else {
                    // Otherwise, treat it as a valid payload (assumed to be an object)
                    set({ loading: true });

                    const response = await service.GetSchemeConversionRateList(payloadd);


                    set({
                        conversionRateControl: response.data,
                        loading: false,
                    });
                }
            } catch (err) {
                console.error('Controls fetch error:', err);
                set({ error: err?.response?.data?.error?.message || 'Failed to fetch scheme controls.', loading: false });
            }
        },

        fetchParentSchemeDetails: async (parentId) => {
            set({ loading: true, error: null });
            try {
                const service = await SchemeDefinitionService;
                const response = await service.GetSchemeDetails(parentId);

                set({
                    parentSchemeDetails: response.data,
                    loading: false,
                });
            } catch (err) {
                console.error('Parent scheme fetch error:', err);
                set({ error: err?.response?.data?.error?.message || 'Failed to fetch parent scheme details.', loading: false });
            }
        },

        updateSchemeDetails: (updatedFields) => {
            set((state) => ({
                schemeDetails: {
                    ...state.schemeDetails,
                    ...updatedFields,
                }
            }));
        },

        getSchemeDocuments: async (id, docNames) => {
            set({ error: null });
            try {
                const service = await SchemeDefinitionService;
                const responses = await Promise.all(
                    docNames.map(docName => service.SchemeDocuments(id, docName?.Name))
                );
                const allDocuments = responses.flatMap(res => res.data || []);
                set({ schemeDocuments: allDocuments });
            } catch (err) {
                console.error(err);
                set({ error: err?.response?.data?.error?.message || 'Failed to fetch scheme documents.' });
            }
        },

        fetchSchemeSlabControls: async () => {
            set({ loading: true, error: null });
            try {
                const service = await SchemeDefinitionService;

                const [
                    slabControlsRes,
                    discountControlsRes,
                    giftControlsRes,
                    freeItemControlsRes
                ] = await Promise.all([
                    service.GetSchemeSlabMandatoryData(),
                    service.Discount(),
                    service.Gift(),
                    service.FreeItem()
                ]);

                set({
                    schemeSlabControls: slabControlsRes.data,
                    slabPopupDiscountControls: discountControlsRes.data,
                    slabPopupGiftControls: giftControlsRes.data,
                    slabPopupFreeitemControls: freeItemControlsRes.data,
                    loading: false,
                });
            } catch (err) {
                console.error('Error fetching slab popup controls:', err);
                set({ error: err?.response?.data?.error?.message || 'Failed to fetch slab popup controls.', loading: false });
            }
        },

        fetchThresholdSettings: async () => {
            set({ loading: true, error: null });
            try {
                const service = await SchemeDefinitionService;
                const response = await service.GetThresholdSetting();
                set({
                    thresholdSettings: response.data,
                    loading: false,
                });
            } catch (err) {
                console.error('Error fetching threshold settings:', err);
                set({ error: err?.response?.data?.error?.message || 'Failed to fetch threshold settings.', loading: false });
            }
        },
    };
});

